import React from 'react';

const SaturationPointer = () => {
  return <div className="saturation-pointer" />;
};

export default SaturationPointer;
